import useFileSaver from '@hooks/useFileSaver';
import useRequest, { IDataRequest } from '@hooks/useRequest';
import { EnumEmpresa } from '@model/Empresa';
import IFatura, { FaturaTipo } from '@model/Fatura';
import React from 'react';

export interface IRelatorioValoresEmitidosFilter {
    competencia: string
    empresaId?: EnumEmpresa
    tipo?: FaturaTipo
}

export interface IRelatorioValoresEmitidosRecord extends IFatura {
    quantidade: number
    total: number
}

const controller = '/Relatorio/ValoresEmitidos';

export function useRelatorioValoresEmitidosService () {
    const _request = useRequest();
    const fileSaver = useFileSaver();

    const listar = React.useCallback((request: IDataRequest<IRelatorioValoresEmitidosFilter>) => {
        return _request.getData<IRelatorioValoresEmitidosRecord[]>(`${controller}/Listar`, request);
    }, [_request]);

    const exportar = React.useCallback((request: IDataRequest<IRelatorioValoresEmitidosFilter>) => {
        return _request.download(`${controller}/Exportar`, {
            params: request
        })
            .then(response => { 
                fileSaver.save(response, `Valores-Emitidos.csv`);
            });
    }, [_request, fileSaver]);

    return React.useMemo(() => ({
        listar, exportar
    }), [listar, exportar]);
}